import {
  CheckCircle, CreditCard, Clock, Eye, Glasses, Info, Mail, MapPin, Phone, RotateCcw, Shield, ShieldCheck,
  Star, Stethoscope, Store, Truck, Wrench,
} from 'lucide-react'

const ICONS = {
  mail: Mail, phone: Phone, 'map-pin': MapPin, clock: Clock, store: Store, star: Star, shield: Shield, 'shield-check': ShieldCheck,
  truck: Truck, rotate: RotateCcw, check: CheckCircle, glasses: Glasses, eye: Eye, stethoscope: Stethoscope, wrench: Wrench,
  card: CreditCard, info: Info,
}

// Icons offered in the dashboard are referred to by name; unknown or blank names render nothing.
export default function ContentIcon({ name, ...props }) {
  const Icon = ICONS[name]
  return Icon ? <Icon {...props} /> : null
}
